import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import React from "react";
import { StyledH4Heading } from "../style/StyledComponents";
import { useTheme } from "@emotion/react";

const QuickMarkBoard = ({openQuickMarksDialog, timeStampsText, setOpenQuickMarksDialog, handleStringToBookmarks, setTimeStampsText}) => {
    const theme = useTheme();
    return (
        <Dialog open={openQuickMarksDialog} onClose={() => {setOpenQuickMarksDialog(false)}}>
            <DialogTitle><StyledH4Heading>Read Bookmarks</StyledH4Heading></DialogTitle>
            <DialogContent>
                <Typography paragraph>
                Import a list of time stamps with titles. Such lists are often provided in the 
                description of long videos. Please use the format shown in the example below.
                </Typography>
                <TextField
                  autoFocus
                  multiline
                  margin="dense"
                  label="Example Time Stamps"
                  type="text"
                  fullWidth
                  value={ "0:30 Intro\n2:14 Topic1\n ..." }
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                    autoFocus
                    multiline
                    rows={6}
                    margin="dense"
                    id="name"
                    label="Enter Your Time Stamps"
                    type="text"
                    fullWidth
                    value={timeStampsText}
                    onChange={(e) => setTimeStampsText(e.target.value)}
                    />
                <DialogActions>
                    <Button
                        variant="contained" 
                        style={{
                            backgroundColor: theme.palette.primary.main,
                            height: "100%",
                            textTransform: 'capitalize'
                        }}
                        sx={{ paddingTop: "10px" }}
                        onClick={(e) => {handleStringToBookmarks(e);setOpenQuickMarksDialog(false)}} 
                        color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default QuickMarkBoard;